import { render, staticRenderFns } from "./instfooter.vue?vue&type=template&id=79ebcd9c&scoped=true"
import script from "./instfooter.vue?vue&type=script&lang=js"
export * from "./instfooter.vue?vue&type=script&lang=js"
import style0 from "./instfooter.vue?vue&type=style&index=0&id=79ebcd9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ebcd9c",
  null
  
)

export default component.exports